import React from 'react';
import { Filter, SafeHtml } from '@shared/ui';
import { CdnIcon } from '@shared/ui';
import { useTheme } from '../../../../../theme';
const ExchangeRefundBreadcrumbs = ({ breadcrumbs }) => {
    const { ExchangeRefundBreadcrumbs: css } = useTheme('Entities').Order;
    return (React.createElement(React.Fragment, null, breadcrumbs.map(breadcrumb => (React.createElement(Filter, { key: breadcrumb.id, classes: { root: css.breadcrumb }, icon: breadcrumb.icon ? React.createElement(CdnIcon, { icon: breadcrumb.icon }) : undefined, label: React.createElement(SafeHtml, { html: breadcrumb.label, tag: 'span' }), isSelected: true, size: "large", quantity: breadcrumb.passengersCount, onClick: breadcrumb.onAction, isDisabled: breadcrumb.disabled })))));
};
export default ExchangeRefundBreadcrumbs;
